import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ index, children, dark = false }) => (
  <div className="flex items-center gap-4 mb-6" data-testid={`section-label-${index}`}>
    <span className={`font-monodata text-xs ${dark ? "text-blue-400" : "text-accent"}`}>{index}</span>
    <span className={`h-px w-10 ${dark ? "bg-white/25" : "bg-slate-300"}`} />
    <span className={`uppercase tracking-[0.25em] text-xs font-semibold ${dark ? "text-slate-400" : "text-slate-500"}`}>
      {children}
    </span>
  </div>
);

export { EASE };
